import React, { FormEvent } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.scss";
import currencies from "./currencies.json";
import Select from "react-select";

const options: Array<{ value: string; label: string }> = [];
for (const i in currencies) {
	//@ts-ignore
	const c = currencies[i];
	options.push({ value: c.code, label: `${c.code} - ${c.description}` });
}
interface Props {}
class App extends React.Component<
	Props,
	{
		from: string;
		to: string;
		amount: number;
		result: {
			from: string;
			to: string;
			amount: number;
			converted: number;
			rate: number;
		};
	}
> {
	constructor(props: any) {
		super(props);
		this.state = {
			from: "EUR",
			to: "USD",
			amount: 1,
			result: {
				from: "",
				to: "",
				amount: 0,
				converted: 0,
				rate: 0,
			},
		};
	}
	handleChangeFrom = (selectedOption: any) => {
		this.setState({ from: selectedOption.value });
	};
	handleChangeTo = (selectedOption: any) => {
		this.setState({ to: selectedOption.value });
	};
	switch = () => {
		this.setState({ from: this.state.to, to: this.state.from });
	};
	handleChangeInput = (event: any) => {
		//@ts-ignore
		const v = document.getElementById("quantity").value;
		if (!v) return;
		this.setState({ amount: v });
	};
	submit = (event: FormEvent) => {
		event.preventDefault();
		this.convert();
	};
	convert() {
		fetch(
			`https://api.exchangerate.host/convert?from=${this.state.from}&to=${this.state.to}&amount=${this.state.amount}`
		)
			.then((res) => res.json())
			.then((res) => {
				console.log(res);
				this.setState({
					result: {
						from: res.query.from,
						to: res.query.to,
						amount: res.query.amount,
						converted: Math.round(res.result * 1000) / 1000,
						rate: Math.round(res.info.rate * 1000) / 1000,
					},
				});
			});
	}
	render() {
		return (
			<div className="container py-4">
			<div className="App-quitar">

<header className="pb-3 mb-5 mt-4 border-bottom text-center">
    <h1>  <a href="/" className="text-dark text-decoration-none">
       
        <span>Convertidor de divisas</span>
      </a></h1>
    </header>

<div className="row align-items-md-stretch  h-100 p-5 bg-light border rounded-3">



<div className="col-md-4"><h6>De</h6>
<div className="text-bg-light rounded-3">
<Select options={options} className="basic-single" defaultValue={options.find((c) => c.value === "GBP")} onChange={this.handleChangeFrom}
value={options.find((c) => c.value === this.state.from) || options.find((c) => c.value === "GBP")}/>
 </div>
</div>


<div className="col-md-1 text-center" ><br />
<button aria-label="Cambiar" type="button" title="Cambiar" className="" onClick={this.switch} style={{display: "inline-flex",
border: "1px solid rgb(221, 221, 221)",borderRadius: "50%",padding: "16px"}}>
<svg style={{ width: "16px",height: "16px",color: "rgb(0, 108, 224)",transform: "rotate(0deg)"}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17" aria-hidden="true">
<path fill="currentColor" fill-rule="evenodd" d="M11.726 1.273l2.387 2.394H.667V5h13.446l-2.386 2.393.94.94 4-4-4-4-.94.94zM.666 12.333l4 4 .94-.94L3.22 13h13.447v-1.333H3.22l2.386-2.394-.94-.94-4 4z" clip-rule="evenodd"></path></svg>
</button>

</div>

<div className="col-md-4"><h6>a</h6>
<div className="bg-light border rounded-3">
<Select options={options} className="basic-single" defaultValue={options.find((c) => c.value === "USD")} onChange={this.handleChangeTo} value={
options.find((c) => c.value === this.state.to) || options.find((c) => c.value === "USD")}/>
</div>
</div>
<div className="col-md-3  mt-2" >
<form onSubmit={this.submit}>
<h6>Importe</h6>
<input type="number" id="quantity" name="quantity" min="0.01" step="0.01" defaultValue="1" onChange={this.handleChangeInput}
style={{border: "none",borderBottom: "2px solid #0af",backgroundColor: "inherit",}}/>
<input type="submit" value="Convertir" className="btn btn-primary mt-4" />
</form>
</div>
<br />
<div className="col-md-6 text-left small">
<svg style={{ width: "16px",height: "16px",color: "rgb(0, 108, 224)",marginLeft:"-4px",marginRight:"4px"}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" aria-hidden="true" ><path fill="currentColor" fill-rule="evenodd" d="M8.571 11.429V6.286H6.286v1.143h1.143v4H5.714v1.142h4.572V11.43H8.57zM8 2.857a.857.857 0 100 1.714.857.857 0 000-1.714zM8 16A8 8 0 118 0a8 8 0 010 16zM8 1.143a6.857 6.857 0 100 13.714A6.857 6.857 0 008 1.143z" clip-rule="evenodd"></path></svg>
Usamos la tasa del mercado medio para nuestro conversor. Esto solo tiene fines informativos. No recibirás esta tasa cuando envíes dinero.	
</div>
<div className="col-md-12 text-center"><br />
<p className="fs-4">{this.state.result.converted? `${this.state.result.amount} ${this.state.result.from} = ${this.state.result.converted} ${this.state.result.to}`: ``}</p>
<i className="fs-5">{this.state.result.rate? `Cambio: 1 ${this.state.result.from} = ${this.state.result.rate} ${this.state.result.to}`: ``}</i>
</div>

</div>
</div>



			</div>
		);
	}
}

export default App;
